import { pushTo } from '@app/core/routing';
import { adminAuditPaths } from '@app/modules/audit/routing/admin-audit-paths';
import { useAuditReportsGetReportDefinitionByReportType } from '@mi-front/api-v2';
import { QueryView } from '@mi-front/ui';
import { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { Page } from '../../../../../../components/page/Page';

export function ReportDefinitionDefaultEditorPage() {
  const { formatMessage } = useIntl();
  const params = useParams<{ reportType: string }>();

  const reportType = params.reportType;

  const definitionQuery = useAuditReportsGetReportDefinitionByReportType(
    reportType || '',
    undefined, // No blueprintVersion - gets default
    {
      query: {
        refetchOnMount: 'always',
        staleTime: 0,
      },
    },
  );

  useEffect(() => {
    if (definitionQuery.data?.id) {
      // Navigate to the by-id route once we have the definition ID
      pushTo(
        adminAuditPaths.reportDefinitionById(definitionQuery.data.id),
        true, // replace = true to maintain same behavior as history.replace
      );
    }
  }, [definitionQuery.data?.id]);

  if (!reportType) {
    return (
      <Page
        htmlTitle={formatMessage({
          id: 'audit.reportDefinitions.reportTemplateTitle',
          defaultMessage: 'Plantilla de Reporte',
        })}
      >
        <Page.Content>
          <div>
            <FormattedMessage
              id="audit.reportDefinitions.reportTypeRequired"
              defaultMessage="El tipo de reporte es requerido"
            />
          </div>
        </Page.Content>
      </Page>
    );
  }

  return (
    <Page
      htmlTitle={formatMessage({
        id: 'audit.reportDefinitions.reportTemplateTitle',
        defaultMessage: 'Plantilla de Reporte',
      })}
    >
      <Page.Content>
        <QueryView query={definitionQuery}>
          {() => {
            // This should not render as we navigate in useEffect
            // But QueryView handles loading/error states
            return <></>;
          }}
        </QueryView>
      </Page.Content>
    </Page>
  );
}
